import styled from 'styled-components';

const AfterwordContainer = styled.div`
  margin-top: 56px;
  text-align: left;
`;

export default AfterwordContainer;
